import { Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "../../../../core/Api";
import { setListData } from "../../../../redux/slices/listSlice";
import { FileOutlined } from "@ant-design/icons";
import useDevice from "../../../../utils/useDevice";
import moment from "moment";
import Loading from "../../../../components/Loading";

const UserResults = () => {
  const { isMobile } = useDevice();
  const [loading, setLoading] = useState(false);

  const listData = useSelector((state) => state.listSlice.listData);
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const resp = await Api.getCustomerResultsAsync(1000, 1);
      dispatch(setListData(resp.data));
      setLoading(false);
    };
    fetchData();
  }, []);

  const resultHandle = async (idFile) => {
    const results = await Api.getResultUrlAsync(idFile);
    window.open(results.data.data, "_blank");
  };
  // const downloadHandle = async (idFile) => {
  //   const results = await Api.downloadFileAsync(idFile);
  //   window.open(results.data.data, "_blank");
  // };
  const columns = [
    {
      title: "Sonuç Tarihi",
      dataIndex: "resultDate",
      key: "resultDate",
      width: "10%",
    },
    {
      title: "Hasta Sahibi",
      dataIndex: "PatientOwner",
      key: "PatientOwner",
      width: "20%",
    },
    {
      title: "Hasta",
      dataIndex: "Patient",
      key: "Patient",
      width: "10%",
    },
    {
      title: "PACS Sonuçları",
      dataIndex: "Reports",
      key: "Reports",
      width: "20%",
    },
    {
      title: "Durumu",
      key: "Status",
      dataIndex: "Status",
      width: "10%",
      render: (_, status) => (
        <>
          <Tag
            color={
              status.StatusLevel === 3
                ? "green"
                : status.StatusLevel === 2
                ? "red"
                : status.StatusLevel === 1
                ? "blue"
                : "yellow"
            }
            key={status}
          >
            {status.Status}
          </Tag>
        </>
      ),
    },
  ];
  const data =
    listData.data &&
    Array.isArray(listData.data.results) &&
    listData.data.results.map((g) => {
      return {
        key: g.idRatemRequest,
        resultDate: moment(g.appointmentDate).format("LLL"),
        PatientOwner: g.ownerName,
        Patient: g.animalName,
        // Docs: g.files.map((z, index) => {
        //   return (
        //     <div
        //       key={index}
        //       onClick={() => downloadHandle(z.idAllFile)}
        //       className="flex flex-col items-center text-xs hover:opacity-50 duration-300 cursor-pointer text-blue-500 hover:text-blue-400 drop-shadow-sm"
        //     >
        //       <FileOutlined className="text-3xl" />
        //       <span>
        //         {z.fileName ? `${z.fileName.substring(0, 8)}...` : "Dosya"}
        //       </span>
        //     </div>
        //   );
        // }),
        Reports: (
          <div className="grid grid-cols-4 gap-4 items-center text-center">
            {g.requests.map((c) => {
              return (
                <div
                  onClick={() => resultHandle(c.idRatemRequestItem)}
                  className="flex flex-col items-center text-xs hover:opacity-50 duration-300 cursor-pointer text-green-500 hover:text-green-400 drop-shadow-sm"
                >
                  <FileOutlined className="text-3xl" />
                  <span>{c.testItemCode}</span>
                </div>
              );
            })}
          </div>
        ),
        StatusLevel: g.requestLevel,
        Status: g.requestStatus,
      };
    });

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="animate__animated animate__fadeIn">
          <Table
            locale={{ emptyText: <div className="p-12">Kayıt yok.</div> }}
            bordered={true}
            className="p-4"
            columns={columns}
            scroll={{ x: 400 }}
            dataSource={data}
            size={isMobile ? "middle" : "large"}
          />
        </div>
      )}
    </>
  );
};

export default UserResults;
